/**
 * src/ApiUrl.js  —  LEGACY COMPATIBILITY SHIM
 *
 * All API endpoint constants have been moved to src/api/ and grouped by domain.
 * This file re-exports everything from there so existing imports continue to work.
 *
 * ✅ Existing code:   import { API_LOGIN } from '../ApiUrl';     // still works
 * ✅ New code:         import { API_LOGIN } from '../api/auth';   // preferred
 * ✅ Via barrel:       import { API_LOGIN } from '../api';        // also fine
 *
 * Do NOT add new constants to this file. Add them to the appropriate
 * domain module inside src/api/ instead.
 */

import {
  API_URL,
  API_VERSION,
  APP_NAME,
  PANEL_NAME,
  API_TOKEN,
  EMAIL_REGEX,
  PASS_REGEX,
  Numeric,
  ALPHABET,
  ALPHANUMERIC_REGEX,
  PASS_VALIDATION_MSG,
  API_LOGIN,
  API_SHARE_LOCATION,
  DASHBOARD,
  DASHBOARD_FILTERS,
  API_ADD_DISPATCHER,
  API_DELETE_CARTYPE,
  API_GET_DISPATCHER,
  API_EDIT_DISPATCHER,
  API_GET_DISPATCHERS_URL,
  API_DELETE_DISPATCHER,
  API_GET_STORES_URL,
  API_GET_STORES_BY_ID,
  API_ADD_STORES,
  API_EDIT_STORES,
  API_ADD_STORE_BANKAC,
  API_ADD_STORE_DOCS,
  API_GET_STORE_DOCS,
  API_GET_STORES_CATEGORIES,
  API_GET_STORES_CATEGORIE_BY_ID,
  API_ADD_STORES_CATEGORIE,
  API_EDIT_STORES_CATEGORIE,
  API_DELETE_STORES_CATEGORIE,
  API_CATEGORY_ADD_URL,
  API_CATEGORY_LIST_URL,
  API_CATEGORY_GET_URL,
  API_CATEGORY_UPDATE_URL,
  API_CATEGORY_DELETE_URL,
  API_GET_RESTAURANTS_URL,
  API_GET_RESTAURANTS_All,
  API_RESTAURANTS_VIEW_URL,
  API_RESTAURANTS_DELETE_URL,
  API_RESTAURANTS_STATUS_URL,
  API_RESTAURANTS_ADD_URL,
  API_GET_RESTAURANTS_PAYMENTS,
  API_RESTAURANTS_PAYMENTS,
  API_CUISINES_LIST_URL,
  API_CUISINES_ADD_URL,
  API_CUISINES_GET_URL,
  API_CUISINES_UPDATE_URL,
  API_CUISINES_DELETE_URL,
  API_PROMOTIONS_LIST_URL,
  API_PROMOTIONS_ADD_URL,
  API_PROMOTIONS_GET_URL,
  API_PROMOTIONS_UPDATE_URL,
  API_PROMOTIONS_DELETE_URL,
  API_GET_STORES_ITEMS,
  API_GET_STORES_ITEM_BY_ID,
  API_ADD_STORES_ITEM,
  API_EDIT_STORES_ITEM,
  API_DELETE_STORES_ITEM,
  API_UPDATE_STORE_ITEM_STATUS,
  API_GET_DRIVER_URL,
  API_GET_DRIVER,
  API_ADD_DRIVER,
  API_EDIT_DRIVER,
  API_DELETE_DRIVER,
  API_DRIVER_PAYMENTS,
  API_STATUS_CHANGE_RIDER,
  API_BLOCK_RIDER,
  API_GET_ALL_DRIVER_LOCATION,
  API_DRIVER_EARNING,
  API_GET_CUSTOMERS_URL,
  API_GET_CUSTOMER,
  API_ADD_CUSTOMER,
  API_EDIT_CUSTOMER,
  API_DELETE_CUSTOMER,
  API_BLOCK_CUSTOMER,
  API_UPLOAD_CUSTOMER,
  API_GET_ALL_GEOFENCING,
  API_ADD_GEOFANCING,
  API_GET_ID_GEOFENCING,
  API_EDIT_GEOFENCING,
  API_DELETE_GEOFENCING,
  API_GET_ALL_ADMINS,
  API_EDIT_ADMIN,
  API_ADD_ADMIN,
  API_GET_ADMIN,
  API_DELETE_ADMIN,
  API_TOGGLE_SUPPORT_CHAT,
  API_GET_ADMIN_PROFILE,
  API_UPLOAD_SUPPORT_MEDIA,
  API_GET_ALL_PARTNERS,
  API_GET_ALL_PARTNERS_PAGINATION,
  API_EDIT_PARTNER,
  API_ADD_PARTNER,
  API_GET_PARTNER,
  API_DELETE_PARTNER,
  API_GET_PARTNERS_INVOICES,
  API_GET_CONTENT_PAGES_URL,
  API_EDIT_CONTENT_PAGE,
  API_GET_CONTENT_PAGE_BY_ID,
  API_GET_ALL_FAQ,
  API_ADD_FAQ,
  API_EDIT_FAQ,
  API_GET_FAQ,
  API_DELETE_FAQ,
  API_GET_MAIL_TEMPLATES,
  API_GET_MAIL_TEMPLATE,
  API_ADD_MAIL_TEMPLATE,
  API_EDIT_MAIL_TEMPLATE,
  API_GET_SMS_TEMPLATES,
  API_GET_SMS_TEMPLATE,
  API_ADD_SMS_TEMPLATE,
  API_EDIT_SMS_TEMPLATE,
  API_GET_ALL_CAR_TYPES,
  API_GET_CAR_TYPES,
  API_GET_CAR_TYPE_BY_ID,
  API_ADD_CAR_TYPE,
  API_EDIT_CAR_TYPE,
  API_GET_ALL_DRIVER_CARS,
  API_GET_ALL_CARS,
  API_UPDATE_CAR_STATUS,
  API_DELETE_DRIVER_CAR,
  API_ADD_CAR,
  API_CAR_DETAIL,
  API_EDIT_CAR,
  API_GET_ALL_PRICING,
  API_GET_PRICING_BY_ID,
  API_ADD_PRICING,
  API_EDIT_PRICING,
  API_REMOVE_PRICING,
  API_GET_ORDERS,
  API_GET_ORDER_BY_ID,
  API_GET_DRIVER_NEAR_BY,
  ASSIGN_DRIVER_TRIP,
  API_GET_TRIPS_LOCATIONS,
  API_UPDATE_NOTE,
  API_DELETE_TRIP,
  API_GET_ALL_PROMOCODE,
  API_ADD_PROMOCODE,
  API_EDIT_PROMOCODE,
  API_UPDATE_PROMOCODE_STATUS,
  API_GET_PROMOCODE,
  API_DELETE_PROMOCODE,
  SEND_PUSH_NOTIFICATION,
  API_UPDATE_ADMIN_PASSWORD,
  API_GET_BASIC_SETTINGS,
  API_UPDATE_BASIC_SETTINGS,
  API_UPDATE_NOTIFICATION_SETTINGS,
  API_UPDATE_SOCIAL_SETTINGS,
  API_INSTALLATION_SETTINGS,
  API_UPDATE_SMS_INSTALLATION_SETTINGS,
  API_UPDATE_PAYMENT_INSTALLATION_SETTINGS,
  API_UPDATE_MAILGUN_INSTALLATION_SETTINGS,
  API_UPDATE_ANDROID_INSTALLATION_SETTINGS,
  API_UPDATE_IOS_INSTALLATION_SETTINGS,
  API_GET_MAILTEMPLATE,
  API_UPDATE_MAILTEMPLATE,
  API_GET_SMSTEMPALTE,
  API_UPDATE_SMSTEMPALTE,
  API_ADD_ADVERTISEMENT,
  API_GET_ALL_ADVERTISEMENT,
  API_EDIT_ADVERTISEMENT,
  API_DELETE_ADVERTISEMENT,
  API_GET_ID_ADVERTISEMENT,
  API_CHANGE_TRIP_STATUS,
  API_ADD_BANNER,
  API_GET_ALL_BANNER,
  API_EDIT_BANNER,
  API_DELETE_BANNER,
  API_GET_ID_BANNER,
  API_GET_NOTIFICATION,
  API_MANAGE_NOTIFICATION,
  API_GET_NOTIFICATION_COUNT,
  API_GET_DRIVER_STATS,
  API_CUSTOMER_LOGGED_OUT,
  API_ADMIN_UPDATE_CAR,
  API_REGENERATE_INVOICE,
} from './api/index';

export * from './api/index';

const URLS = {
  API_URL,
  API_VERSION,
  APP_NAME,
  PANEL_NAME,
  API_TOKEN,
  EMAIL_REGEX,
  PASS_REGEX,
  Numeric,
  ALPHABET,
  ALPHANUMERIC_REGEX,
  PASS_VALIDATION_MSG,
  API_LOGIN,
  API_SHARE_LOCATION,
  DASHBOARD,
  DASHBOARD_FILTERS,
  API_ADD_DISPATCHER,
  API_DELETE_CARTYPE,
  API_GET_DISPATCHER,
  API_EDIT_DISPATCHER,
  API_GET_DISPATCHERS_URL,
  API_DELETE_DISPATCHER,
  API_GET_STORES_URL,
  API_GET_STORES_BY_ID,
  API_ADD_STORES,
  API_EDIT_STORES,
  API_ADD_STORE_BANKAC,
  API_ADD_STORE_DOCS,
  API_GET_STORE_DOCS,
  API_GET_STORES_CATEGORIES,
  API_GET_STORES_CATEGORIE_BY_ID,
  API_ADD_STORES_CATEGORIE,
  API_EDIT_STORES_CATEGORIE,
  API_DELETE_STORES_CATEGORIE,
  API_CATEGORY_ADD_URL,
  API_CATEGORY_LIST_URL,
  API_CATEGORY_GET_URL,
  API_CATEGORY_UPDATE_URL,
  API_CATEGORY_DELETE_URL,
  API_GET_RESTAURANTS_URL,
  API_GET_RESTAURANTS_All,
  API_RESTAURANTS_VIEW_URL,
  API_RESTAURANTS_DELETE_URL,
  API_RESTAURANTS_STATUS_URL,
  API_RESTAURANTS_ADD_URL,
  API_GET_RESTAURANTS_PAYMENTS,
  API_RESTAURANTS_PAYMENTS,
  API_CUISINES_LIST_URL,
  API_CUISINES_ADD_URL,
  API_CUISINES_GET_URL,
  API_CUISINES_UPDATE_URL,
  API_CUISINES_DELETE_URL,
  API_PROMOTIONS_LIST_URL,
  API_PROMOTIONS_ADD_URL,
  API_PROMOTIONS_GET_URL,
  API_PROMOTIONS_UPDATE_URL,
  API_PROMOTIONS_DELETE_URL,
  API_GET_STORES_ITEMS,
  API_GET_STORES_ITEM_BY_ID,
  API_ADD_STORES_ITEM,
  API_EDIT_STORES_ITEM,
  API_DELETE_STORES_ITEM,
  API_UPDATE_STORE_ITEM_STATUS,
  API_GET_DRIVER_URL,
  API_GET_DRIVER,
  API_ADD_DRIVER,
  API_EDIT_DRIVER,
  API_DELETE_DRIVER,
  API_DRIVER_PAYMENTS,
  API_STATUS_CHANGE_RIDER,
  API_BLOCK_RIDER,
  API_GET_ALL_DRIVER_LOCATION,
  API_DRIVER_EARNING,
  API_GET_CUSTOMERS_URL,
  API_GET_CUSTOMER,
  API_ADD_CUSTOMER,
  API_EDIT_CUSTOMER,
  API_DELETE_CUSTOMER,
  API_BLOCK_CUSTOMER,
  API_UPLOAD_CUSTOMER,
  API_GET_ALL_GEOFENCING,
  API_ADD_GEOFANCING,
  API_GET_ID_GEOFENCING,
  API_EDIT_GEOFENCING,
  API_DELETE_GEOFENCING,
  API_GET_ALL_ADMINS,
  API_EDIT_ADMIN,
  API_ADD_ADMIN,
  API_GET_ADMIN,
  API_DELETE_ADMIN,
  API_TOGGLE_SUPPORT_CHAT,
  API_GET_ADMIN_PROFILE,
  API_UPLOAD_SUPPORT_MEDIA,
  API_GET_ALL_PARTNERS,
  API_GET_ALL_PARTNERS_PAGINATION,
  API_EDIT_PARTNER,
  API_ADD_PARTNER,
  API_GET_PARTNER,
  API_DELETE_PARTNER,
  API_GET_PARTNERS_INVOICES,
  API_GET_CONTENT_PAGES_URL,
  API_EDIT_CONTENT_PAGE,
  API_GET_CONTENT_PAGE_BY_ID,
  API_GET_ALL_FAQ,
  API_ADD_FAQ,
  API_EDIT_FAQ,
  API_GET_FAQ,
  API_DELETE_FAQ,
  API_GET_MAIL_TEMPLATES,
  API_GET_MAIL_TEMPLATE,
  API_ADD_MAIL_TEMPLATE,
  API_EDIT_MAIL_TEMPLATE,
  API_GET_SMS_TEMPLATES,
  API_GET_SMS_TEMPLATE,
  API_ADD_SMS_TEMPLATE,
  API_EDIT_SMS_TEMPLATE,
  API_GET_ALL_CAR_TYPES,
  API_GET_CAR_TYPES,
  API_GET_CAR_TYPE_BY_ID,
  API_ADD_CAR_TYPE,
  API_EDIT_CAR_TYPE,
  API_GET_ALL_DRIVER_CARS,
  API_GET_ALL_CARS,
  API_UPDATE_CAR_STATUS,
  API_DELETE_DRIVER_CAR,
  API_ADD_CAR,
  API_CAR_DETAIL,
  API_EDIT_CAR,
  API_GET_ALL_PRICING,
  API_GET_PRICING_BY_ID,
  API_ADD_PRICING,
  API_EDIT_PRICING,
  API_REMOVE_PRICING,
  API_GET_ORDERS,
  API_GET_ORDER_BY_ID,
  API_GET_DRIVER_NEAR_BY,
  ASSIGN_DRIVER_TRIP,
  API_GET_TRIPS_LOCATIONS,
  API_UPDATE_NOTE,
  API_DELETE_TRIP,
  API_GET_ALL_PROMOCODE,
  API_ADD_PROMOCODE,
  API_EDIT_PROMOCODE,
  API_UPDATE_PROMOCODE_STATUS,
  API_GET_PROMOCODE,
  API_DELETE_PROMOCODE,
  SEND_PUSH_NOTIFICATION,
  API_UPDATE_ADMIN_PASSWORD,
  API_GET_BASIC_SETTINGS,
  API_UPDATE_BASIC_SETTINGS,
  API_UPDATE_NOTIFICATION_SETTINGS,
  API_UPDATE_SOCIAL_SETTINGS,
  API_INSTALLATION_SETTINGS,
  API_UPDATE_SMS_INSTALLATION_SETTINGS,
  API_UPDATE_PAYMENT_INSTALLATION_SETTINGS,
  API_UPDATE_MAILGUN_INSTALLATION_SETTINGS,
  API_UPDATE_ANDROID_INSTALLATION_SETTINGS,
  API_UPDATE_IOS_INSTALLATION_SETTINGS,
  API_GET_MAILTEMPLATE,
  API_UPDATE_MAILTEMPLATE,
  API_GET_SMSTEMPALTE,
  API_UPDATE_SMSTEMPALTE,
  API_ADD_ADVERTISEMENT,
  API_GET_ALL_ADVERTISEMENT,
  API_EDIT_ADVERTISEMENT,
  API_DELETE_ADVERTISEMENT,
  API_GET_ID_ADVERTISEMENT,
  API_CHANGE_TRIP_STATUS,
  API_ADD_BANNER,
  API_GET_ALL_BANNER,
  API_EDIT_BANNER,
  API_DELETE_BANNER,
  API_GET_ID_BANNER,
  API_GET_NOTIFICATION,
  API_MANAGE_NOTIFICATION,
  API_GET_NOTIFICATION_COUNT,
  API_GET_DRIVER_STATS,
  API_CUSTOMER_LOGGED_OUT,
  API_ADMIN_UPDATE_CAR,
  API_REGENERATE_INVOICE,
};

export default URLS;
